/** @type {Styles} */
export const styles = {
  radioGroup: {
    gap: 1,
    '.MuiButtonBase-root': {
      color: 'gray.40',
    },
  },
  labelContainer: { marginBottom: 1, display: 'flex', alignItems: 'center' },
  label: {
    color: 'gray.80',
    typography: 'header4',
  },
  tooltip: {
    padding: 0.5,
    py: 0,
  },
}
